<div class="grid__col-12 guts-p-t-4">
  <div class="page-header">
    <div class="l_flexbar m-l_flexbar-block">
      <!-- Page title -->
      <div class="page-header__title l_flex-grow">
        <div class="l_flex l_flex-wrap grid--align-center">
          <div class="guts-m-r-2 m-guts-m-r-0">
            <span
              *ngIf="!isFeatured && showPlanSimplification"
              class="par par--small font-medium guts-m-b-quart ib"
              >{{ specificTargetTypeDisplayName }}</span
            >
            <h1 *ngIf="target.title" class="page-header__title__text h1 break">
              {{ target.title }}
            </h1>
          </div>
        </div>
      </div>

      <!-- Page actions -->
      <div
        class="page-header__actions l_flex-top l_flex--align-right m-guts-p-t-1 m-l_flex-col"
      >
        <div class="l_flex">
          <!-- Share -->
          <dgx-action-button
            class="flex-framework-actions__button"
            *ngIf="canRecommend && !isEditing"
            icon="arrow-forward"
            design="square"
            size="md"
            [isIconOnly]="true"
            [autoToggleState]="false"
            [tooltip]="'Core_Recommend' | translate"
            (click)="recommend($event)"
            dgatInput="pageActionOptions-recommend"
          ></dgx-action-button>

          <!-- Clone -->
          <dgx-action-button
            *ngIf="canClone && !isEditing"
            class="flex-framework-actions__button"
            icon="square-double"
            design="square"
            size="md"
            [isIconOnly]="true"
            [autoToggleState]="false"
            [tooltip]="'Core_Clone' | translate"
            (click)="clone()"
            dgatInput="pageActionOptions-clone"
          ></dgx-action-button>

          <!-- Reorder -->
          <dgx-action-button
            *ngIf="canEdit && isEditing"
            class="flex-framework-actions__button"
            icon="arrow-up-down"
            design="square"
            size="md"
            [isIconOnly]="true"
            [autoToggleState]="false"
            [tooltip]="'FlexCtrl_ReorderSections' | translate"
            (click)="reorderRows()"
            dgatInput="pageActionOptions-reorder"
          ></dgx-action-button>

          <!-- Settings -->
          <dgx-menu
            *ngIf="canEdit && !isFeatured"
            [menuConfig]="settingsMenuConfig"
            [autoCloseOnItemSelect]="true"
          >
            <dgx-action-button
              class="flex-framework-actions__button"
              icon="gear"
              design="square"
              size="md"
              [isIconOnly]="true"
              [autoToggleState]="false"
              [tooltip]="'Core_Settings' | translate"
              dgatInput="pageActionOptions-settings"
            ></dgx-action-button>
          </dgx-menu>

          <!-- Featured plan settings -->
          <dgx-action-button
            *ngIf="canEdit && isFeatured && !isEditing"
            class="flex-framework-actions__button"
            icon="gear"
            design="square"
            size="md"
            [isIconOnly]="true"
            [autoToggleState]="false"
            [tooltip]="'Core_Settings' | translate"
            (click)="editTarget()"
            dgatInput="pageActionOptions-settings"
          >
          </dgx-action-button>

          <!-- Edit/Done -->
          <button
            *ngIf="canEdit"
            df-button
            class="flex-framework-actions__button flex-view__edit-btn"
            [class]="isEditing ? '' : 'bg-color-white'"
            [dfButtonType]="isEditing ? 'primary' : 'passive'"
            (click)="toggleEdit()"
            data-dgat="pageActionOptions-editMode"
          >
            <df-spinner-button [isSpinning]="isLeavingEditMode">
              <df-icon icon="pencil" class="guts-m-r-half"></df-icon>
              {{ editButtonText }}
            </df-spinner-button>
          </button>

          <!-- Follow/Following -->
          <dgx-action-button
            *ngIf="canFollow && !isEditing"
            class="flex-framework-actions__button"
            icon="{{ isFollowing ? 'checkmark' : 'plus' }}"
            design="square"
            size="md"
            [isIconOnly]="true"
            [autoToggleState]="false"
            [isActive]="isFollowing"
            [tooltip]="
              (isFollowing ? 'Core_Following' : 'Core_Follow') | translate
            "
            (click)="toggleFollow()"
            dgatInput="pageActionOptions-follow"
          ></dgx-action-button>
        </div>
      </div>
    </div>

    <div
      *ngIf="target.description"
      class="grid__col-12 guts-p-t-1-half guts-p-b-0 guts-p-l-0 guts-p-r-0 par markdown"
    >
      <dgx-text-expander
        [content]="target.description | markdownToHtml: { allowImages: true }"
        [isHtml]="true"
        [maxCollapsedLines]="2"
        [useReadMore]="true"
        [collapse]="targetType !== 'Browse'"
      ></dgx-text-expander>
    </div>
  </div>

  <dgx-flex-meta-data
    *ngIf="!isFeatured"
    class="guts-p-t-3"
    [target]="target"
    [isEditing]="isEditing"
    (editCollaborators)="editCollaborators()"
  ></dgx-flex-meta-data>
</div>
